<template>
  <div class="hero-slide-root">
    <BaseImage
      :media-object="content.imageObject"
      :sizes="{ md: 1920 }"
      :loading="loading"
      class="hero-slide-image"
    />
    <HeroSliderSlideBody
      :title="displayTitle"
      :heading-type="content.seoHeadingtype"
      :subtitle="displaySubtitle"
      :intro="displayIntro"
      :link-object1="content.linkObject1"
    />
  </div>
</template>

<script setup lang="ts">
  import type { HeroSlideContent } from '@/types/heroSlider'

  const props = defineProps<{
    content: HeroSlideContent
    loading?: 'eager' | 'lazy'
    singleHeader?: boolean
  }>()

  const displayTitle = computed(() => props.content.title ?? '')
  const displaySubtitle = computed(() => props.content.subtitle ?? '')
  const displayIntro = computed(() => props.content.intro ?? '')
</script>

<style scoped lang="scss">
  .hero-slide-root {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  .hero-slide-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(270deg, rgba(0, 0, 0, 0) 59.03%, rgba(0, 0, 0, 0.4) 100%);
    }

    :deep(.image-wrapper) {
      width: 100%;
      height: 100%;
      object-fit: cover;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
